import LightMapStyleImg from "resources/images/mapStyles/light.jpg";
import DarkMapStyleImg from "resources/images/mapStyles/dark.jpg";
import StreetMapStyleImg from "resources/images/mapStyles/street.jpg";
import SatelliteMapStyleImg from "resources/images/mapStyles/satellite.jpg";
import { scaleThreshold } from "d3-scale";

import HYBRID from "resources/images/MapType/hybrid.png";
import ROADMAP from "resources/images/MapType/roadmap.png";
import SATELLITE from "resources/images/MapType/satellite.png";
import TERRAIN from "resources/images/MapType/terrain.png";

import Polygon from "resources/images/MapDrawerType/ic_polygon.png";
import Polyline from "resources/images/MapDrawerType/ic_polyline.png";
import Rectangle from "resources/images/MapDrawerType/ic_rectangle.png";
import Circle from "resources/images/MapDrawerType/ic_circle.png";

import PolygonWhite from "resources/images/MapDrawerType/ic_polygon_white.png";
import PolylineWhite from "resources/images/MapDrawerType/ic_polyline_white.png";
import RectangleWhite from "resources/images/MapDrawerType/ic_rectangle_white.png";
import CircleWhite from "resources/images/MapDrawerType/ic_circle_white.png";

const appPrefix = "LISA_APP";

export const AsyncKey = {
  languageKey: appPrefix + "_LANGUAGE",
};

const DEFAULT_GEOJSON_DRAWING = {
  type: "FeatureCollection",
  features: [],
};

const COLOR_SCALE = scaleThreshold()
  .domain([
    0, 1000, 2000, 4000, 6000, 8000, 10000, 12000, 15000, 18000, 20000, 30000,
  ])
  .range([
    [65, 182, 196],
    [127, 205, 187],
    [199, 233, 180],
    [237, 248, 177],
    // zero
    [255, 255, 204],
    [255, 237, 160],
    [254, 217, 118],
    [254, 178, 76],
    [253, 141, 60],
    [252, 78, 42],
    [227, 26, 28],
    [189, 0, 38],
    [128, 0, 38],
  ]);

const MAP_STYLES = [
  { title: "Light", styleCode: "light-v10", styleImg: LightMapStyleImg },
  { title: "Dark", styleCode: "dark-v10", styleImg: DarkMapStyleImg },
  { title: "Street", styleCode: "streets-v11", styleImg: StreetMapStyleImg },
  {
    title: "Satellite",
    styleCode: "satellite-v9",
    styleImg: SatelliteMapStyleImg,
  },
];

const Constant = {
  mapTypes: [
    { name: "Road Map", image: ROADMAP, id: "roadmap" },
    { name: "Hybrid", image: HYBRID, id: "hybrid" },
    { name: "Satellite", image: SATELLITE, id: "satellite" },
    { name: "Terrain", image: TERRAIN, id: "terrain" },
  ],
  backendUrl:
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_LIS_BACKEND_API_URL
      : process.env.REACT_APP_LIS_BACKEND_URL,
      //: 'https://be-luandev.ap.ngrok.io',
  apiBaseUrl: process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_LIS_BACKEND_API_URL
      : 'http://local.lisa.com:7777/api/v1/',
      //: 'https://be-luandev.ap.ngrok.io/api/v1/',
  // backendUrl: process.env.REACT_APP_LIS_BACKEND_API_URL,
  // apiBaseUrl: process.env.REACT_APP_LIS_BACKEND_API_URL,
  permissionTypes: [
    "edit",
    "view",
    "edit_all_children",
    "view_all_children",
    "edit_tag",
  ],
  itemObjectTypes: ["datasource", "database", "table", "field", "dashboard"],
  itemObjectTypesPlural: [
    "datasources",
    "databases",
    "tables",
    "fields",
    "dashboards",
  ],
  MAP_STYLES,
  SITE_IMAGE_ATTRIBUTES: [
    { key: "photo", name: "Ảnh mặt tiền" },
    {
      key: "photo_front_200m_same_lane",
      name: "Mặt tiền (200m từ hướng xe cùng chiều)",
    },
    {
      key: "photo_front_200m_opposite_lane",
      name: "Mặt tiền (200m từ hướng xe ngược chiều)",
    },
    { key: "parking_area_photo_1", name: "Ảnh bãi xe (1)" },
    { key: "parking_area_photo_2", name: "Ảnh bãi xe (2)" },
    { key: "parking_area_photo_3", name: "Ảnh bãi xe (3)" },
    { key: "left_angle_photo", name: "Ảnh góc trái" },
    { key: "right_angle_photo", name: "Ảnh góc phải" },
    { key: "surrounding_photo", name: "Ảnh khu vực xung quanh" },
    { key: "inside_photo", name: "Ảnh bên trong mặt bằng" },
    {
      key: "surrounding_photo_busy_time",
      name: "Ảnh xung quanh (giờ cao điểm)",
    },
    { key: "street_photo_non_busy_time", name: "Ảnh đường (giờ thường)" },
    { key: "street_photo_busy_time", name: "Ảnh đường (giờ cao điểm)" },
    { key: "other_street_photo", name: "Ảnh các đường khác" },
    // { key: 'bar_photo_front', name: 'Ảnh quầy bar (chụp từ trước)' },
    // { key: 'bar_photo_back', name: 'Ảnh quầy bar (chụp từ trong ra)' },
    { key: "ground_floor_photo", name: "Ảnh tầng trệt" },
    { key: "1st_floor_photo", name: "Ảnh tầng 1" },
    { key: "2nd_floor_photo", name: "Ảnh tầng 2" },
    { key: "3rd_floor_photo", name: "Ảnh tầng 3" },
  ],
  EXTERNAL_SITE_IMAGE_ATTRIBUTES: [
    "photo",
    "left_angle_photo",
    "right_angle_photo",
  ],
  MAPBOX_API_ACCESS_TOKEN:
    "pk.eyJ1IjoiZHV5bHVhbnRjaCIsImEiOiJjanl0anNqajIwMXJiM2NtMWh6bHkyZDk1In0.fBcCjnInTTP6ZiZYQhSV2g",
  SITE_REQUIRED_FIELDS: [
    "store_site_type",
    "site_position_type",
    "store_format",
    "primary_site_surrounding_area_type",
    // 'secondary_site_surrounding_area_type',
    "address_number",
    "street_name",
    "lease_rate",
    "area",
    "name",
  ],
  MARRKET_LOCATION_SITE_REQUIRED_FIELDS: [
    "address_number",
    "street_name",
    "name",
  ],
  EXTERNAL_SITE_REQUIRED_FIELDS: [
    "address_number",
    "street_name",
    "longitude",
    "latitude",
    "area",
    "floor_count",
    "facade_length",
    "initial_lease_rate",
    "contact_name",
    "contact_phone",
  ],
  STORE_IMAGE_ATTRIBUTES: [
    // Store images
    { key: "photo", name: "Ảnh mặt tiền" },
    {
      key: "photo_front_200m_same_lane",
      name: "Mặt tiền (200m từ hướng xe cùng chiều)",
    },
    {
      key: "photo_front_200m_opposite_lane",
      name: "Mặt tiền (200m từ hướng xe ngược chiều)",
    },
    { key: "bar_photo_front", name: "Ảnh quầy bar (chụp từ trước)" },
    { key: "bar_photo_back", name: "Ảnh quầy bar (chụp từ trong ra)" },
    { key: "ground_floor_photo", name: "Ảnh tầng trệt" },
    { key: "1st_floor_photo", name: "Ảnh tầng 1" },
    { key: "2nd_floor_photo", name: "Ảnh tầng 2" },
    { key: "3rd_floor_photo", name: "Ảnh tầng 3" },
    // Parking images
    { key: "parking_area_photo_1", name: "Ảnh bãi xe (1)" },
    { key: "parking_area_photo_2", name: "Ảnh bãi xe (2)" },
    { key: "parking_area_photo_3", name: "Ảnh bãi xe (3)" },
    { key: "car_parking_area_photo_1", name: "Ảnh bãi xe hơi (1)" },
    { key: "car_parking_area_photo_2", name: "Ảnh bãi xe hơi (2)" },
    // Surrounding area images
    { key: "street_photo_busy_time", name: "Ảnh đường (giờ cao điểm)" },
    { key: "street_photo_non_busy_time", name: "Ảnh đường (giờ thường)" },
    { key: "surrounding_photo", name: "Ảnh khu vực xung quanh (giờ thường)" },
    {
      key: "surrounding_photo_busy_time",
      name: "Ảnh xung khu vực xung quanh (giờ cao điểm)",
    },
    { key: "other_street_photo", name: "Ảnh các đường khác xung quanh" },
  ],
  HeatMapRadius: 20,
  RetailGradient: [
    "rgba(250, 159, 181, 0)",
    "rgba(250, 159, 181, 1)",
    "rgba(247, 104, 161, 1)",
    "rgba(221, 52, 151, 1)",
    "rgba(174, 1, 126, 1)",
    "rgba(122, 1, 119, 1)",
    "rgba(73, 0, 106, 1)",
  ],
  FoodAndBeverageGradient: [
    "rgba(186, 255, 226, 0)",
    "rgba(186, 255, 226, 1)",
    "rgba(93, 186, 191, 1)",
    "rgba(248, 192, 170, 1)",
    "rgba(235, 156, 128, 1)",
    "rgba(221, 119, 85, 1)",
    "rgba(208, 83, 43, 1)",
  ],
  staticGradient: [
    "rgba(250, 227, 0, 0)",
    "rgba(250, 227, 0, 1)",
    "rgba(250, 194, 0, 1)",
    "rgba(253, 121, 0, 1)",
    "rgba(227, 26, 26, 1)",
    "rgba(207, 23, 80, 1)",
    "rgba(174, 14, 127, 1)",
  ],
  COLOR_RANGE: {
    BLUE_RANGE: [
      [204, 235, 197, 200],
      [168, 221, 181, 200],
      [78, 179, 211, 200],
      [43, 140, 190, 200],
      [8, 104, 172, 200],
      [8, 64, 129, 200],
    ],
    PURPLE_RANGE: [
      [250, 159, 181, 200],
      [247, 104, 161, 200],
      [221, 52, 151, 200],
      [174, 1, 126, 200],
      [122, 1, 119, 200],
      [73, 0, 106, 200],
    ],
    ORANGE_RANGE: [
      [250, 227, 0, 200],
      [250, 194, 0, 200],
      [253, 121, 0, 200],
      [227, 26, 26, 200],
      [207, 23, 80, 200],
      [174, 14, 127, 200],
    ],
    SKY_ORANGE_RANGE: [
      [186, 225, 226, 200],
      [93, 186, 191, 200],
      [248, 192, 170, 200],
      [235, 156, 128, 200],
      [221, 119, 85, 200],
      [208, 83, 43, 200],
    ],
  },
  COLOR_SCALE,
  DEFAULT_GEOJSON_DRAWING,
  MAP_DRAWING_TYPE: [
    { name: "polygon", image: Polygon, active: PolygonWhite },
    { name: "polyline", image: Polyline, active: PolylineWhite },
    { name: "rectangle", image: Rectangle, active: RectangleWhite },
    { name: "circle", image: Circle, active: CircleWhite },
  ],
};

export default Constant;
